<template>
  <article class="ProductCard">
    <SanityImageBackground v-if="content.image || defaultImage"
      class="image"
      :asset="(content.image || defaultImage).asset"
    />
    <div class="text">
      <h2 class="title">{{ content.title }}</h2>
      <button class="cta" @click="() => showProductModal(content)">
        {{ ctaText }}
        <span class="arrow" v-html="arrowRightSvg" />
      </button>
    </div>
  </article>
</template>

<script>
import strings from '../strings.json'

import arrowRightSvg from '~/assets/ui/arrow-right.svg?raw'

export default {
  inject: ['locale', 'showProductModal'],
  props: {
    content: {
      type: Object,
      required: true,
    },
    defaultImage: {
      type: Object,
    },
  },
  computed: {
    ctaText() {
      return strings[this.locale].viewResources
    },
  },
  data() {
    return {
      arrowRightSvg,
    }
  },
}
</script>

<style scoped>

.ProductCard {
  display: block;
  height: 100%;
  border: thin solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.image {
  padding-top: 55%;
}

.text {
  padding: var(--spacing-6) var(--spacing-5);
}

.title {
  /* These rules are required for -webkit-line-clamp */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow-y: hidden;
}

.title {
  margin-top: var(--spacing-1);
  font-weight: 500;
  font-size: var(--font-size-2);
  line-height: 1.5;
  -webkit-line-clamp: 2;
}

.cta {
  margin-top: var(--spacing-5);
  display: inline-block;
  font-weight: 400;
  font-size: var(--font-size-1);
  line-height: 1;
  color: var(--brand-color);
  cursor: pointer;
}

.cta .arrow {
  margin-left: 0.75em;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  left: 0;
  transition: left 0.15s;
}

.cta:hover .arrow {
  left: 4px;
}
</style>
